<header>
	<div class="search-form" [formGroup]="searchForm">
		<mat-form-field
			class="mr-xxxs search-field"
			title="Busca de organizações"
			appearance="outline"
		>
			<mat-label>Pesquisar</mat-label>
			<input
				id="sms-sro"
				type="text"
				matInput
				placeholder="Pesquisar"
				formControlName="term"
				(keyup)="onSearchKeyUp($event)"
				(input)="onSearch()"
			/>
		</mat-form-field>
		<mat-form-field appearance="outline" class="ml-xxxs">
			<mat-label>Filtrar por Produto</mat-label>
			<mat-select formControlName="productFilter">
				<mat-option
					*ngFor="let option of productFilterOptions"
					[value]="option.value"
				>
					{{ option.viewValue }}
				</mat-option>
			</mat-select>
		</mat-form-field>
	</div>
	<button
		mat-flat-button
		color="primary"
		routerLink="cadastro"
		*ngIf="isCreateEnabled"
	>
		<mat-icon>add</mat-icon>
		<span class="hide-on-mobile">Novo Cliente</span>
	</button>
</header>

<div class="loader" *ngIf="isLoading">
	<mat-spinner diameter="20"></mat-spinner>
</div>
<ng-container *ngIf="organizations.length && !isLoading">
	<div class="card" *ngFor="let organization of organizations">
		<div class="organization-resume">
			<div class="organization-group">
				<div class="organization-icon">
					<mat-icon svgIcon="sanus-business"></mat-icon>
				</div>
				<span class="organization-name to-ellipsis">
					{{ organization.name_economic_group || organization.name_secondary }}
				</span>
			</div>
			<div class="head-col hide-on-mobile">
				<span class="information-label">Total de usuários</span>
				<span class="information-value">
					{{ organization._count.totalUsers }}
				</span>
			</div>
			<div class="head-col">
				<span class="information-label">
					Total
					<span class="hide-on-mobile">de beneficiários</span>
				</span>
				<span class="information-value">
					{{ organization._count.totalBeneficiaries }}
				</span>
			</div>
			<div class="d-f gap-lg">
				<ng-container
					*ngIf="
						organization.products && organization.products.length > 0;
						else noProductTag
					"
				>
					<ng-container
						*ngFor="let prod of organization.products; let i = index"
					>
						<mat-chip
							[ngClass]="getProductTagClass(prod.products.name)"
							selected
							small
						>
							{{ prod.products.name }}
						</mat-chip>
					</ng-container>
				</ng-container>
				<ng-template #noProductTag>
					<mat-chip selected small>Sem Produto</mat-chip>
				</ng-template>
			</div>
		</div>
		<div class="separator"></div>
		<app-organization-info
			[cnpj]="organization.cnpj | mask: '00.000.000/0000-00'"
			[id]="organization.id"
			[name]="organization.name_secondary"
			[isFavorite]="organization.isFavorite"
			[isMatriz]="organization.is_matriz"
			[state]="organization.address.state | statelabel"
			[totalBeneficiaries]="organization._count.beneficiaries || 0"
			[totalUsers]="organization._count.users || 0"
			(editGroup)="onEditGroup(organization.id, $event)"
			(toggleFavoriteClicked)="onToggleFavorite(organization.id)"
		></app-organization-info>
		<ng-container *ngFor="let subsidiary of organization.subsidiaries">
			<app-organization-info
				[cnpj]="subsidiary.cnpj | mask: '00.000.000/0000-00'"
				[id]="subsidiary.id"
				[name]="subsidiary.name_secondary"
				[isFavorite]="subsidiary.isFavorite"
				[isMatriz]="subsidiary.is_matriz"
				[state]="subsidiary.address.state | statelabel"
				[totalBeneficiaries]="subsidiary._count.beneficiaries"
				[totalUsers]="subsidiary._count.users"
				(toggleFavoriteClicked)="onToggleFavorite(subsidiary.id)"
				(editGroup)="onEditGroup(subsidiary.id, $event)"
			></app-organization-info>
		</ng-container>
	</div>
	<app-pagination
		[limit]="limit"
		[count]="count"
		[currentPage]="currentPage"
		[totalPages]="totalPages"
		(pageChange)="onPageChange($event)"
	></app-pagination>
	<div class="pb-huge">&nbsp;</div>
</ng-container>
